import { render } from "./MemberRegistration.vue?vue&type=template&id=a1f54b36&scoped=true"
import script from "./MemberRegistration.vue?vue&type=script&lang=js"
export * from "./MemberRegistration.vue?vue&type=script&lang=js"

import "./MemberRegistration.vue?vue&type=style&index=0&id=a1f54b36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f54b36"],['__file',"src/views/MemberRegistration/MemberRegistration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1f54b36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1f54b36', __exports__)) {
    api.reload('a1f54b36', __exports__)
  }
  
  module.hot.accept("./MemberRegistration.vue?vue&type=template&id=a1f54b36&scoped=true", () => {
    api.rerender('a1f54b36', render)
  })

}


export default __exports__